import { asyncRouterMap, constantRouterMap } from '@/config/router.config'

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permissionList
 * @param route
 * @returns {boolean}
 */
function hasPermission(permissionList: any, route: any) {
	if (route.meta && route.meta.permission) {
		let flag = false
		const len = permissionList.length
		for (let i = 0; i < len; i++) {
			flag = route.meta.permission.includes(permissionList[i])
			if (flag) {
				return true
			}
		}
		return false
	}
	return true
}

/**
 * 单账户多角色时，使用该方法可过滤角色不存在的菜单
 *
 * @param roles
 * @param route
 * @returns {*}
 */
// eslint-disable-next-line
function hasRole(roles: any, route: any) {
	if (route.meta && route.meta.roles) {
		return route.meta.roles.includes(roles.id)
	} else {
		return true
	}
}

function filterAsyncRouter(routerMap: any, roles: any) {
	const accessedRouters = routerMap.filter((route: any) => {
		const permissionList = roles.menuPermissions
		if (hasPermission(permissionList, route)) {
			if (route.children && route.children.length) {
				route.children = filterAsyncRouter(route.children, roles)
			}
			return true
		}
		return false
	})
	return accessedRouters
}

const permission = {
	namespaced: true,
	state: {
		routers: constantRouterMap,
		addRouters: [],
	},
	mutations: {
		SET_ROUTERS: (state: any, routers: any) => {
			state.addRouters = routers
			state.routers = constantRouterMap.concat(routers)
		},
	},
	actions: {
		GenerateRoutes(state: any, data: any) {
			return new Promise((resolve: () => any) => {
				const { roles } = data
				const accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
				state.commit('SET_ROUTERS', accessedRouters)
				resolve()
			})
		},
	},
}

export default permission
